var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVizlaLogoLightSide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "80px",
    viewBox: "0 0 300 80",
    style: {
      enableBackground: "new 0 0 300 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2E4D8;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#60BFC0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.7,71.3 31.2,50.3 24.4,54.2 67.7,79.1 110.9,54.2 104.1,50.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67.7,57.1 31.4,36.1 24.4,40.2 67.7,65.1 110.9,40.2 103.9,36.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "108.7,47.6 115.4,51.6 135.3,40.1 116.2,29 109.3,33 121.9,40.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "26.7,47.7 20,51.6 0,40.1 19.1,29 25.8,32.9 13.5,40.1  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "110.9,25.9 67.7,0.9 24.4,25.9 67.7,50.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.3,52.5l10.8-31.1h8.4l-14.6,38.2h-9.4L155,21.3h8.5L174.3,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.7,14.8c-1-1-1.5-2.2-1.5-3.6c0-1.4,0.5-2.6,1.5-3.6c1-1,2.2-1.5,3.6-1.5c1.4,0,2.6,0.5,3.5,1.5 c1,1,1.5,2.2,1.5,3.6c0,1.4-0.5,2.6-1.5,3.6s-2.1,1.5-3.5,1.5C200.9,16.3,199.7,15.8,198.7,14.8z M206.2,21.3v38.2h-7.9V21.3 H206.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.6,53.1H239v6.5h-26.5v-6.5l17.4-25.3h-17.4v-6.5H239v6.5L221.6,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.9,8.2v51.3H246V8.2H253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.1,30.1c1.6-3,3.8-5.3,6.5-6.9c2.8-1.6,5.8-2.5,9.1-2.5c3,0,5.6,0.6,7.9,1.8c2.2,1.2,4,2.6,5.4,4.4v-5.5 h8v38.2h-8v-5.7c-1.3,1.8-3.2,3.3-5.5,4.5c-2.3,1.2-4.9,1.8-7.9,1.8c-3.3,0-6.3-0.8-9-2.5c-2.7-1.7-4.9-4-6.5-7.1 c-1.6-3-2.4-6.5-2.4-10.3C260.7,36.4,261.5,33,263.1,30.1z M290.4,33.5c-1.1-1.9-2.5-3.4-4.3-4.4c-1.8-1-3.7-1.5-5.7-1.5 c-2,0-3.9,0.5-5.7,1.5c-1.8,1-3.2,2.5-4.3,4.4c-1.1,1.9-1.6,4.2-1.6,6.8s0.5,4.9,1.6,6.9c1.1,2,2.5,3.5,4.3,4.5 c1.8,1,3.7,1.6,5.7,1.6c2,0,3.9-0.5,5.7-1.5c1.8-1,3.2-2.5,4.3-4.5c1.1-2,1.6-4.3,1.6-6.9S291.5,35.5,290.4,33.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVizlaLogoLightSide);
export default __webpack_public_path__ + "static/media/vizla-logo-light-side.d79639dfe93311e7ffc17c846ab87fa4.svg";
export { ForwardRef as ReactComponent };